<template>
  <div>
    <vs-table hover-flat v-if="consultations && consultations.length" :data="consultations">

      <template slot="thead">
        <vs-th v-text="$t('no')"></vs-th>
        <vs-th v-text="$t('caller_company_name')" v-if="activeColumns.includes('caller_company_name')"></vs-th>
        <vs-th v-text="$t('name')" v-if="activeColumns.includes('name')"></vs-th>
        <vs-th v-text="$t('mobile')" v-if="activeColumns.includes('mobile')"></vs-th>
        <vs-th v-text="$t('landline')" v-if="activeColumns.includes('landline')"></vs-th>
        <vs-th v-text="$t('email')" v-if="activeColumns.includes('email')"></vs-th>
        <vs-th v-text="$t('member_groups')" v-if="activeColumns.includes('member_groups')"></vs-th>
        <vs-th v-text="$t('inquiry')" v-if="activeColumns.includes('inquiry')"></vs-th>
        <vs-th v-text="$t('big')" v-if="activeColumns.includes('big')"></vs-th>
        <vs-th v-text="$t('small')" v-if="activeColumns.includes('small')"></vs-th>
        <vs-th v-text="$t('counselor')" v-if="activeColumns.includes('counselor')"></vs-th>
        <vs-th v-text="$t('result')" v-if="activeColumns.includes('result')"></vs-th>
        <vs-th v-text="$t('consulting_title')" v-if="activeColumns.includes('consulting_title')"></vs-th>
        <vs-th v-text="$t('consultation_contents')" v-if="activeColumns.includes('consultation_contents')"></vs-th>
        <vs-th v-text="customField.name" v-for="(customField, key) in customFields" v-bind:key="'consultationCustomFieldHeader_' + key" v-if="activeColumns.includes(`custom_field_${customField.id}`)"></vs-th>
        <vs-th v-text="$t('date_of_receipt')"></vs-th>
        <vs-th v-text="$t('time')"></vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
          <vs-td v-text="tr.count" :data-tr-title="$t('no')"></vs-td>
          <vs-td v-if="activeColumns.includes('caller_company_name')" :data-tr-title="$t('caller_company_name')">
            <a href="#" v-text="tr.company_name" @click.prevent="$emit('callerCompanyPopup', tr.company_name)"></a>
          </vs-td>
          <vs-td v-if="activeColumns.includes('name')" :data-tr-title="$t('name')">
            <a href="#" v-text="tr.member_name" @click.prevent="$emit('openOutboundPopup', tr.member_id, tr.id)"></a>
          </vs-td>
          <vs-td v-if="activeColumns.includes('mobile')" :data-tr-title="$t('mobile')">
            <div class="d-inline-block mr-2" v-if="tr.mobile && tr.mobile.length > 0">
              <a v-if="$stringHelper.contentIsMobile(tr.mobile)" href="#" @click.prevent="openSendSmsPopup(tr.mobile)" v-text="tr.mobile"></a>
              <span v-else v-text="tr.mobile"></span>
            </div>
            <click-to-call v-if="tr.mobile && tr.mobile.length > 0" class="d-inline-block" :phone-number="tr.mobile"></click-to-call>
          </vs-td>
          <vs-td v-if="activeColumns.includes('landline')" :data-tr-title="$t('landline')">
            <div class="d-inline-block mr-2" v-if="tr.landline && tr.landline.length > 0">
              <a v-if="$stringHelper.contentIsMobile(tr.landline)" href="#" @click.prevent="openSendSmsPopup(tr.landline)" v-text="tr.landline"></a>
              <span v-else v-text="tr.landline"></span>
            </div>
            <click-to-call v-if="tr.landline && tr.landline.length > 0" class="d-inline-block" :phone-number="tr.landline"></click-to-call>
          </vs-td>
          <vs-td v-text="tr.email" v-if="activeColumns.includes('email')" :data-tr-title="$t('email')"></vs-td>
          <vs-td v-text="tr.member_group_name" v-if="activeColumns.includes('member_groups')" :data-tr-title="$t('member_groups')"></vs-td>
          <vs-td v-text="tr.inquiry_name" v-if="activeColumns.includes('inquiry')" :data-tr-title="$t('inquiry')"></vs-td>
          <vs-td v-text="tr.big_name" v-if="activeColumns.includes('big')" :data-tr-title="$t('big')"></vs-td>
          <vs-td v-text="tr.small_name" v-if="activeColumns.includes('small')" :data-tr-title="$t('small')"></vs-td>
          <vs-td v-text="tr.counselor_name" v-if="activeColumns.includes('counselor')" :data-tr-title="$t('counselor')"></vs-td>
          <vs-td v-text="tr.result_name" v-if="activeColumns.includes('result')" :data-tr-title="$t('result')"></vs-td>
          <vs-td v-if="activeColumns.includes('consulting_title')" :data-tr-title="$t('consulting_title')">
            <a href="#" @click.prevent="$emit('openEditConsultationPopup', tr.member_id, tr.id)">
              {{ $stringHelper.limitString(tr.title, 15) }}
            </a>
          </vs-td>
          <vs-td v-if="activeColumns.includes('consultation_contents')" :data-tr-title="$t('consultation_contents')">
            {{ $stringHelper.limitString(tr.content, 15) }}
          </vs-td>
          <vs-td v-for="(customField, key) in customFields" v-bind:key="'consultationCustomField_' + key" v-if="activeColumns.includes(`custom_field_${customField.id}`)" :data-tr-title="customField.name">
            <span v-for="(customFieldData, key) in tr.custom_fields" v-bind:key="'consultationCustomFieldData_' + key">
              <span v-if="customFieldData.custom_field_id == customField.id">{{ customFieldData.value }}</span>
            </span>
          </vs-td>
          <vs-td v-text="tr.date_of_receipt" :data-tr-title="$t('date_of_receipt')"></vs-td>
          <vs-td v-text="tr.reception_hours" :data-tr-title="$t('time')"></vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <vs-alert v-else class="flex justify-center p-0 h-auto" color="danger" active="true">
      <div v-text="$t('no_record')"></div>
    </vs-alert>
  </div>
</template>

<script>
import ClickToCall  from '@/components/buttons/ClickToCall'
import {EventBus} from '@/../eventbus'

export default {
  name: 'Shared.Consultations.Consultations.List',
  components: {
    ClickToCall
  },
  props: {
    consultations: {
      type: [Object, Array],
      required: true
    },
    customFields: {
      type: [Object, Array],
      required: true
    },
    activeColumns: {
      type: [Object, Array],
      required: true
    }
  },
  methods: {
    openSendSmsPopup (number) {
      EventBus.$emit('initSendSmsPopup', number)
    }
  }
}
</script>

<style scoped>

</style>
